import { render, staticRenderFns } from "./BaseUpload.vue?vue&type=template&id=3cd4b676&scoped=true&"
import script from "./BaseUpload.vue?vue&type=script&lang=js&"
export * from "./BaseUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4b676",
  null
  
)

export default component.exports